import config from '@epi-config';
/* eslint-disable no-undef */

export const isProduction = (): boolean => {
  return process.env.NODE_ENV === 'production';
};

export const isQa = (): boolean => {
  if (config.environment) {
    return false;
  }

  return config.environment.includes('QA');
};

export const isProductionConfig = (): boolean => {
  if (!config.environment) {
    return false;
  }

  return config.environment.includes('PRODUCTION');
};
